export default {
  // SHARED KEYS
  "provider_text_loading-message_validating-address": "Please wait, your address is being verified",
  "provider_text_no-address-matches": "No address matches found. Please enter a complete address.",
  "provider_text_loading-message": "Saving Provider…",
  "provider_text_success-message": "Your provider information has been saved.",
  "___provider_text_error-message_default": "",
  "___provider_action_done": "",
  "provider_action_submit": "Save Provider",
  "___provider_form-label_provider-name": "",
  "___provider_form-label_addr-1": "",
  "___provider_form-label_addr-2": "",
  "___provider_form-label_city": "",
  "___provider_form-label_state": "",
  "___provider_form-label_zip": "",
  "___provider_form-label_phone": "",
  "___provider_form-label_account-number": "",
  "___provider_form-label_confirm-account-number": "",
  "provider_form-error_provider-name_required": "Enter the provider name",
  "provider_form-error_provider-name_length": "Provider name cannot be longer than %maxLength% characters.",
  "provider_form-error_addr-1_required": "Enter address line 1",
  "provider_form-error_addr-1_length": "Address line 1 cannot be longer than %maxLength% characters.",
  "provider_form-error_addr-2_length": "Address line 1 cannot be longer than %maxLength% characters.",
  "provider_form-error_city_required": "Enter the city",
  "provider_form-error_city_length": "City cannot be longer than %maxLength% characters.",
  "provider_form-error_state_required": "Select the state",
  "provider_form-error_zip_required": "Enter the zip code",
  "provider_form-error_zip_invalid-format": "The provider’s Zip Code must contain 5 or 9 digits",
  "provider_form-error_account-number_required": "Enter the account number",
  "provider_form-error_account-number_length": "Account number cannot be longer than %maxLength% characters.",
  "provider_form-error_confirm-account-number_required": "Re-enter the account number",
  "provider_form-error_confirm-account-number_same-as": "Provider Account Numbers do not match",
  "provider_form-error_phone_required": "Enter the provider phone number",
  "___provider_form-error_phone_invalid-format": "",
  "___provider_form-hint_phone": "",
  "___provider_form-hint_zip": "",

  // ADD PROVIDER
  "___add-provider_page-title": "",
  "add-provider_page-description": "Add a provider who can be reimbursed from your account.",
  "___add-provider_text_loading-message_validating-address": "",
  "___add-provider_text_no-address-matches": "",
  "___add-provider_text_loading-message": "",
  "___add-provider_text_success-message": "",
  "___add-provider_text_error-message_default": "",
  "___add-provider_action_done": "",
  "___add-provider_action_submit": "",
  "___add-provider_title_confirm-close": "",
  "___add-provider_text_confirm-close": "",
  "___add-provider_action_confirm-close_cancel": "",
  "___add-provider_action_confirm-close_confirm": "",
  "add-provider_text_refresh-data-error-message": "The provider has been added but we were unable to refresh the data on the screen. Please refresh the page.",

  // UPDATE PROVIDER
  "update-provider_page-title": "Edit Provider",
  "update-provider_page-description": "Enter your temporary PIN below and then use the form to update your provider.",
  "___update-provider_text_loading-message_validating-address": "",
  "___update-provider_text_no-address-matches": "",
  "___update-provider_text_loading-message": "",
  "___update-provider_text_success-message": "",
  "___update-provider_text_error-message_default": "",
  "___update-provider_action_done": "",
  "___update-provider_action_submit": "",
  "___update-provider_title_confirm-close": "",
  "___update-provider_text_confirm-close": "",
  "___update-provider_action_confirm-close_cancel": "",
  "___update-provider_action_confirm-close_confirm": "",
  "update-provider_text_refresh-data-error-message": "The provider has been updated but we were unable to refresh the data on the screen. Please refresh the page.",

  // REMOVE PROVIDER
  "remove-provider_page-title": "Are you sure you want to delete this provider?",
  "remove-provider_page-description": "By deleting this provider you won't be able to pay any bills to this provider.",
  "___remove-provider_action_done": "",
  "___remove-provider_action_cancel": "",
  "___remove-provider_action_confirm": "",
  "___remove-provider_title_confirm-close": "",
  "___remove-provider_text_confirm-close": "",
  "___remove-provider_action_confirm-close_cancel": "",
  "___remove-provider_action_confirm-close_confirm": "",
  "remove-provider_text_loading-message": "Removing Provider…",
  "remove-provider_text_success-message": "The provider was removed successfully. A notification email has been sent to your account.",
  "___remove-provider_text_error-message_default": "",
  "remove-provider_text_refresh-data-error-message": "The provider has been deleted but we were unable to refresh the data on the screen. Please refresh the page.",
};